<template>
  <el-dialog
    title="提示"
    width="30%"
    :before-close="handleClose"
    :visible.sync="tipParmas.tipsVisible"
    :close-on-click-modal="false"
  >
    <div class="title">{{ tipParmas.code==302?'视频已下架':'暂无权限观看视频' }}</div>
    <div class="content">{{ tipParmas.code==302?'如有疑问请联系管理员':'管理员已将您从当前课程移除，如有疑问请联系管理员' }}</div>
    <span slot="footer" class="dialog-footer">
      <el-button class="sure" type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    tipParmas: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
      <style lang="scss" scoped>
      ::v-deep{
        .el-dialog__header{
            background: #F7F8FA;
        }
      }
   .title{
      font-size: 15px;
      color: #303030;
      text-align: center;
   }
   .content{
      font-size: 14px;
      color: #909090;
      margin-top: 12px;
      text-align: center;
   }
      </style>

